import { siteInfo } from '@/mocks/homeData';

export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-16 md:pt-[72px]">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>
      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-5">
              <i className="ri-sparkling-line"></i>
              <span>下拉式 · 弹窗 · 翻页 三种阅读模式</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              {siteInfo.name} · 你的随身漫画图书馆
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              {siteInfo.heroIntro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-500">3,000+</div>
                <div className="text-xs text-foreground-500 mt-1">部漫画作品</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">热门连载不断档</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-500">全免费</div>
                <div className="text-xs text-foreground-500 mt-1">无需付费订阅</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                开始探索漫画
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-secondary-300 text-foreground-700 font-medium rounded-full hover:bg-secondary-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 via-accent-200/20 to-primary-100/40 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20manga%20and%20webtoon%20collage%20with%20various%20anime%20characters%20in%20dynamic%20poses%2C%20Korean%20Japanese%20Chinese%20comic%20art%20styles%20blended%2C%20warm%20energetic%20atmosphere%2C%20digital%20illustration%2C%20eye-catching%20composition%20with%20soft%20glowing%20effects%2C%20modern%20editorial%20design%20aesthetic%2C%20rich%20warm%20color%20palette%20with%20coral%20and%20rose%20accents&width=1200&height=900&seq=hero-main-2026&orientation=landscape"
                alt="女神漫画 - 韩漫日漫国漫在线阅读平台"
                className="relative w-full rounded-2xl object-cover"
                style={{ aspectRatio: '4/3' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}